import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import { profile } from '../data/profile';
import PostItem from '../components/ui/PostItem';
import SectionTitle from '../components/ui/SectionTitle';

export default function Blog() {
  return (
    <section>
      <div className="container">
        <SectionTitle title="技术文章" />
        <p className="page-intro">
          早期技术博客归档，部分文章托管于 Hexo 旧站。
        </p>
        <div className="posts-list">
          {posts.map((post) => (
            <PostItem key={post.title} {...post} />
          ))}
        </div>
        <p className="archive-note">
          更多归档见{' '}
          <a href={profile.archive} target="_blank" rel="noopener noreferrer">
            Hexo 旧站
          </a>
          {' · '}
          <Link to="/">返回首页</Link>
        </p>
      </div>
    </section>
  );
}
